import React from 'react';

import { IconButton, Paper, Typography } from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';

interface PageNavigationProps {
    currentPage: number;
    totalPages: number;
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}

const PageNavigation: React.FC<PageNavigationProps> = ({currentPage, totalPages, setCurrentPage}) => {
    const handleNext = () => {
        setCurrentPage(prev => Math.max(prev - 1, 0))
    }

    const handlePrev = () => {
        setCurrentPage(prev => Math.min(prev + 1, totalPages - 1));
    }

    return (
        <Paper elevation={3} sx={{mt: 2, padding: 2, borderRadius: 3, display: 'flex', justifyContent: 'space-between'}}>
            <IconButton  disabled={currentPage === 0} onClick={handleNext}>
                <ArrowBack />
            </IconButton>
            <Typography alignSelf='center' variant="body2" color="textSecondary">Page {currentPage + 1} of {totalPages}</Typography>
            <IconButton disabled={currentPage >= totalPages - 1} onClick={handlePrev}>
                <ArrowForward />
            </IconButton>
        </Paper>
    )
}

export default PageNavigation;